var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyReportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Outlined Gradient",
    viewBox: "0 0 283.46 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 30.91,
    x2: 252.55,
    y1: 53.37,
    y2: 230.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#47abe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 68.38,
    x2: 212.38,
    y1: 559.93,
    y2: 707.27,
    gradientTransform: "translate(0 -506)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 53.01,
    x2: 197.01,
    y1: 574.94,
    y2: 722.29,
    gradientTransform: "translate(0 -506)",
    xlinkHref: "#a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M141.73 5.6A136.13 136.13 0 0 1 238 238 136.13 136.13 0 0 1 45.47 45.47 135.25 135.25 0 0 1 141.73 5.6m0-5.6a141.73 141.73 0 1 0 141.73 141.73A141.74 141.74 0 0 0 141.73 0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Primary Icons"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M203.5 73.9v5.6h21.6l-59.7 60.8-23.4-23-75.7 69.8V91.9h130.4v-5.6h-136v110.3h161.4v-86.5h-5.6V191H70.3l71.6-65.9 23.5 23.1 64-65.1v20.7h5.6V73.9h-31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M229.4 204H54.1V79.6H197V74H48.5v135.6H235v-99.7h-5.6V204z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyReportIcon);
export default __webpack_public_path__ + "static/media/empty-report-icon.58012c00b122142def3972f2c426fc16.svg";
export { ForwardRef as ReactComponent };